import { isEmpty, isNil, not, pipe } from "ramda";

export const notEmpty = (value) => not(isEmpty(value));

export const isBlank = (value) =>
  value === undefined || isNil(value) || isEmpty(value);

export const notBlank = (value) => not(isBlank(value));

export const daysBetween = pipe(
  (date1, date2) => date2.getTime() - date1.getTime(),
  (difInTime) => difInTime / (1000 * 3600 * 24)
);
